<template>
  <button type="button" class="trigger" :class="{ active, compact, labelled }">
    <slot />
  </button>
</template>

<script setup lang="ts">
// The one icon-trigger shell shared by the list-header controls (SortMenu,
// FilterMenu) so siblings can't drift apart visually.
defineProps<{ active?: boolean; compact?: boolean; labelled?: boolean }>()
</script>

<style scoped>
.trigger {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-1);
  width: 34px;
  height: 34px;
  padding: 0;
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-md);
  background: var(--color-bg-surface);
  color: var(--color-text-secondary);
  cursor: pointer;
}
.trigger.compact { width: 28px; height: 28px; }
.trigger.labelled { width: auto; padding: 0 var(--space-3); }
.trigger:hover { color: var(--color-text-primary); border-color: var(--color-border-strong); }
.trigger.active { color: var(--color-accent); border-color: var(--color-accent); }
</style>
